
export function filterByStatus(statuses, series, statusType) {
   // Filter + sort statuses by updatedAt DESC
    const matchingStatuses =
        statuses
            ?.filter((status) => status.userStatus === statusType)
            .sort(
                (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
            ) ?? [];

    // Create a lookup map to preserve order
    const seriesMap = new Map(
        series?.map((s) => [s._id, s]) ?? []
    );

    // Build filteredSeries in the same order as statuses
    const filteredSeries =
        matchingStatuses
            .map((status) => seriesMap.get(status.seriesId))
            .filter(Boolean);

    return { filteredSeries };
}